import type { IStickerMessageEntity } from "../../shared/entities";
import type { IMessageEntityClass } from "./message";
import { MessageEntityClass } from "./message";

export interface IStickerMessageEntityClass extends IMessageEntityClass<IStickerMessageEntity> {}

export class StickerMessageEntityClass
	extends MessageEntityClass<IStickerMessageEntity>
	implements IStickerMessageEntityClass
{
	private content_: IStickerMessageEntity["content"];

	constructor(
		type: string,
		content: IStickerMessageEntity["content"],
		msgId: string,
		cliMsgId: string,
		fromUid: string,
		toUid: string,
		sendDttm: number,
	) {
		super(type, msgId, cliMsgId, fromUid, toUid, sendDttm);

		this.content_ = content;
	}

	public toPlainObject(): IStickerMessageEntity {
		return {
			type: "sticker",

			msgId: this.msgId_,
			cliMsgId: this.cliMsgId_,
			fromUid: this.fromUid_,
			toUid: this.toUid_,

			ttl: this.ttl_,

			sendDttm: this.sendDttm_,

			localDttm: this.localDttm_,
			serverTime: this.serverTime_,

			content: this.content_,

			urgency: this.urgency_,

			e2eeStatus: this.e2eeStatus_,
		};
	}

	public updateContent(v: IStickerMessageEntity["content"]): void {
		//BIZ RULE: We can or cannot modify message content after a specific message created?
		this.content_ = v;
	}
}
